import CreatorMyPageCategoryTopLayout from "src/components/common/layouts/CreatorMyPageCategoryTopLayout"
import DefaultLayout from "src/components/common/layouts/DefaultLayout"
import Link from "next/link"
import routes from "routes"
import { useCallback } from "react"
import { IllustrationData } from "src/models/tieup/illustration/IllustrationData"
import TieupImg from "src/components/common/TieupImg"
import HTMLHead from "src/components/utils/HTMLHead"
import { useLoadMore } from "src/components/hooks/useLoadMore"
import { usePermission } from "src/components/hooks/usePermission"
import { SizeType } from "../../../../components/common/TieupImg/SizeType"

const PAGE_SIZE = 15

const CreatorMypageIllustration: React.FC = () => {
  usePermission([2])
  const getKey = useCallback((index: number) => {
    return `/v1/mypage/illustration?is_r18=yes&offset=${
      index * PAGE_SIZE
    }&limit=${PAGE_SIZE}`
  }, [])

  const { data, hasNext, isLoadingMore, intersectionRef, onLoadMore } =
    useLoadMore<IllustrationData>(getKey)

  return (
    <DefaultLayout isCreatorMyPage={true}>
      <HTMLHead path="creator/mypage/illustrations" />
      <CreatorMyPageCategoryTopLayout navActive="illustrations">
        <h2 className="p-creatorMypage-title">イラスト一覧</h2>

        <div className="creatorMypage-illust-add p-button">
          <Link href={routes.creatorMyPageIllustrationNew()}>
            <a className="c-button-secondary -full">新規イラスト登録</a>
          </Link>
        </div>

        <div className="creatorMypage-illust-list">
          {data.map((illustration: IllustrationData) => (
            <article
              key={illustration.id}
              className="creatorMypage-illust-item"
            >
              <div className="creatorMypage-illust-image">
                {illustration.url && (
                  <Link
                    href={routes.creatorMyPageIllustrationEdit(illustration.id)}
                  >
                    <a className="creatorMypage-illust-image-anchor">
                      <TieupImg
                        src={illustration.url}
                        size={SizeType.m}
                        alt={`${illustration.title}`}
                      />
                    </a>
                  </Link>
                )}
              </div>
              <h2 className="creatorMypage-illust-title">
                <Link
                  href={routes.creatorMyPageIllustrationEdit(illustration.id)}
                >
                  <a className="creatorMypage-illust-title-anchor">
                    {illustration.title}
                  </a>
                </Link>
              </h2>
            </article>
          ))}
        </div>
        <div className="p-button -spacer-sm">
          {hasNext && (
            <button
              disabled={isLoadingMore}
              onClick={onLoadMore}
              className="c-button-secondary -outline -full"
              ref={intersectionRef}
            >
              もっと見る
            </button>
          )}
        </div>
      </CreatorMyPageCategoryTopLayout>
    </DefaultLayout>
  )
}

export default CreatorMypageIllustration
